import { X } from "lucide-react";

export default function Modal({ darkMode, isOpen, onClose, title, children, onSubmit, submitText, onCancel }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 font-sans antialiased">
      <div
        className={`relative w-full max-w-md rounded-lg p-6 shadow-xl ${
          darkMode ? "border border-[#3C3C4C] bg-[#1D1D1D] text-gray-100" : "border border-gray-200 bg-white text-gray-900"
        }`}
      >
        <button
          type="button"
          onClick={onClose}
          className={`absolute right-2 top-2 rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-redhalo-red/40 ${
            darkMode ? "text-gray-400 hover:text-gray-100" : "text-gray-500 hover:text-gray-800"
          }`}
        >
          <X size={24} />
        </button>
        <h2 className="mb-4 text-xl font-bold">{title}</h2>
        {children}
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            onClick={onSubmit}
            className="rh-btn-primary rounded-md px-4 py-2 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-redhalo-red/50 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-[#1D1D1D]"
          >
            {submitText}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="rounded-md border border-gray-300 bg-gray-100 px-4 py-2 text-sm font-medium text-gray-800 transition hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-redhalo-red/30 dark:border-[#3C3C4C] dark:bg-[#2a2a2a] dark:text-gray-200 dark:hover:bg-[#333]"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}